/**
 * B614 (c) — the SHOW face's summary head (555:78's cart card): the show's
 * thumbnail (photos[0] at 192, 96×72 r8), the headliner (SS3-SB 16), the
 * night in words (SS3 14) and one place line (SS3 12, soft) — "Stand Up Live
 * · 18+ tonight". Every fact is the caller's; an absent one draws nothing.
 */
import type { ReactNode } from "react";
import { sizedPhotoUrl } from "./media.js";

export function ShowSummary(props: {
  readonly title: string;
  readonly when?: string;
  readonly place?: string;
  readonly image?: { readonly url: string; readonly alt?: string };
  readonly redline?: string;
}): ReactNode {
  return (
    <div className="t-showsum" {...(props.redline !== undefined ? { "data-redline": props.redline } : {})}>
      {props.image !== undefined ? <img className="t-showsum-thumb" src={sizedPhotoUrl(props.image.url, 192)} alt={props.image.alt ?? ""} /> : null}
      <div className="t-showsum-words">
        <p className="t-showsum-title">{props.title}</p>
        {props.when !== undefined ? <p className="t-showsum-when">{props.when}</p> : null}
        {props.place !== undefined ? <p className="t-showsum-place">{props.place}</p> : null}
      </div>
    </div>
  );
}
